module.exports = __webpack_public_path__ + "img/icon-sample-orange.65e72b40.svg";